import jwtDecode from 'jwt-decode'

interface TokenValidationResult {
  isValid: boolean
  isExpired: boolean
  decodedToken?: any
  tenantId?: number
  message?: string
}

/**
 * Centralizada função de validação de token JWT
 * Verifica expiração, tenant ID e status de aprovação do usuário
 */
export const validateToken = (token?: string): TokenValidationResult => {
  const tokenToValidate = token || localStorage.getItem('token')
  
  console.log('🔑 [TOKEN-VALIDATION] Iniciando validação do token:', {
    hasTokenParam: !!token,
    hasTokenInStorage: !!localStorage.getItem('token'),
    tokenToValidate: tokenToValidate ? `${tokenToValidate.substring(0, 50)}...` : null,
    timestamp: new Date().toISOString()
  })
  
  if (!tokenToValidate) {
    console.warn('⚠️ [TOKEN-VALIDATION] Token não encontrado')
    return {
      isValid: false,
      isExpired: false,
      message: 'Token não encontrado'
    }
  }

  try {
    console.log('🔑 [TOKEN-VALIDATION] Decodificando token JWT...')
    const decodedToken = jwtDecode(tokenToValidate) as any
    const now = Date.now() / 1000
    const isExpired = decodedToken.exp <= now
    
    console.log('✅ [TOKEN-VALIDATION] Token decodificado:', {
      sub: decodedToken.sub,
      profileId: decodedToken.profileId,
      tenantId: decodedToken.tenantId,
      exp: decodedToken.exp,
      iat: decodedToken.iat,
      isExpired,
      currentTime: now,
      timeUntilExpiry: decodedToken.exp - now
    })
    
    if (isExpired) {
      console.warn('⚠️ [TOKEN-VALIDATION] Token expirado')
      return {
        isValid: false,
        isExpired: true,
        decodedToken,
        message: 'Token expirado'
      }
    }

    const hasTenantId = !!decodedToken.tenantId

    console.log('🔑 [TOKEN-VALIDATION] Verificando tenantId:', {
      tenantId: decodedToken.tenantId,
      hasTenantId
    })

    if (!hasTenantId) {
      console.warn('⚠️ [TOKEN-VALIDATION] TenantId ausente no token')
      return {
        isValid: false,
        isExpired: false,
        decodedToken,
        message: 'TenantId ausente no token'
      }
    }

    console.log('✅ [TOKEN-VALIDATION] Token válido e completo')
    return {
      isValid: true,
      isExpired: false,
      decodedToken,
      tenantId: decodedToken.tenantId,
      message: 'Token válido'
    }

  } catch (error) {
    console.error('❌ [TOKEN-VALIDATION] Erro ao decodificar token:', {
      error: error instanceof Error ? error.message : String(error),
      name: error instanceof Error ? error.constructor.name : 'Unknown',
      stack: error instanceof Error ? error.stack : undefined
    })
    return {
      isValid: false,
      isExpired: false,
      message: 'Erro ao decodificar token'
    }
  }
}

/**
 * Remove token do localStorage e redireciona para login
 */
export const clearTokenAndRedirect = (redirectPath: string = '/') => {
  localStorage.removeItem('token')
  window.location.href = redirectPath
}

/**
 * Valida token e executa ações baseadas no resultado
 */
export const validateTokenAndRedirect = (token?: string): boolean => {
  const tokenToCheck = token || localStorage.getItem('token')
  
  if (!tokenToCheck) {
    console.warn('🚨 Token não encontrado')
    clearTokenAndRedirect()
    return false
  }
  
  const validation = validateToken(tokenToCheck)
  
  if (!validation.isValid) {
    console.warn(`🚨 ${validation.message}`)
    
    if (validation.isExpired) {
      clearTokenAndRedirect()
      return false
    }
    
    clearTokenAndRedirect()
    return false
  }
  
  return true
}